// import React from "react";
// import { useRef ,useState,useEffect} from "react";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import apiClient from "../../api/axiosClient";
// import "../../styles/scoretable.css"

// const ENDPOINT = "/green-hydrogen-scores/";

// const GHscoretable = () => {
//   const tableRef = useRef();
//   const [apiData, setApiData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         //  use apiClient instead of fetch
//         const response = await apiClient.get(ENDPOINT);

//         // axios automatically parses JSON
//         setApiData(response.data.results || []); 
//         setLoading(false);
//       } catch (err) {
//         console.error("API error:", err);
//         setError("Failed to fetch data from API");
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   if (loading) return <div>Loading...</div>;
//   if (error) return <div>{error}</div>;



//   const safeFmt = (v, digits = 2) => {
//     if (v === null || v === undefined || v === "") return "-";
//     // If it's already a number and finite, format it
//     if (typeof v === "number" && Number.isFinite(v)) {
//       return v.toFixed(digits);
//     }
//     // Try convert numeric strings
//     const num = Number(v);
//     if (!Number.isNaN(num) && Number.isFinite(num)) {
//       // return fixed digits (or integer if digits === 0)
//       return digits === 0 ? String(Math.round(num)) : num.toFixed(digits);
//     }
//     try {
//       return String(v);
//     } catch {
//       return "-";
//     }
//   };


//   const companies = apiData.map(item => item.organisation_name);
//   const installed_capacity = apiData.map(item => item.installed_capacity_2024);
//   const installed_capacity_score = apiData.map(item => item.installed_capacity_2024_score);
//   const production_MT =apiData.map(item => item.production_2024);
//   const production_MT_score = apiData.map(item => item.production_2024_score);
//   const carbon_emitted = apiData.map(item => item.carbon_emission_2024);
//   const carbon_emitted_score = apiData.map(item => item.carbon_emission_2024_score);
//   const purity = apiData.map(item => item.purity_2024);
//   const purity_score = apiData.map(item => item.purity_2024_score);
//   const cost_production = apiData.map(item => item.cost_of_production_2024);
//   const cost_production_score = apiData.map(item => item.cost_of_production_2024_score);
//   const investment_production = apiData.map(item => item.installed_capacity_2024);
//   const investment_production_score = apiData.map(item => item.installed_capacity_2024);
//   const growth_investment_2024 = apiData.map(item => item.investment_activities_2024);
//   const growth_investment_score = apiData.map(item => item.growth_invest_gh_score_percent);
//   const growth_investment_2023 = apiData.map(item => item.investment_activities_2023);
//   const investment_electrolyser = apiData.map(item => item.investment_electrolyser_2024);
//   const investment_electrolyser_score = apiData.map(item => item.installed_capacity_2024);
//   const growth_electrolyser = apiData.map(item => item.installed_capacity_2024);
//   const growth_electrolyser_score = apiData.map(item => item.installed_capacity_2024);
//   const patent_filed = apiData.map(item => item.patents_filed_2024);
//   const patent_filed_score = apiData.map(item => item.patents_filed_2024_score);
//   const patent_national = apiData.map(item => item.patents_granted_national_2024);
//   const patent_national_score = apiData.map(item => item.patents_granted_national_2024_score);
//   const patent_international = apiData.map(item => item.patents_granted_international_2024);
//   const patent_international_score = apiData.map(item => item.patents_granted_international_2024_score);
//   const patent_commercial = apiData.map(item => item.patents_commercialized_2024);
//   const patent_commercial_score = apiData.map(item => item.patents_commercialized_2024_score);
//   const project_formula = apiData.map(item => item.installed_capacity_2024);
//   const project_completed_year = apiData.map(item => item.installed_capacity_2024);
//   const project_completion_year = apiData.map(item => item.installed_capacity_2024);
//   const project_capacity = apiData.map(item => item.installed_capacity_2024);
//   const project_status =apiData.map(item => item.installed_capacity_2024);
//   const Total_score = apiData.map(item => item.installed_capacity_2024);
//   const installed_capacity_growth = apiData.map(item => item.installed_capacity_gh_p_unit);
//   const investment_growth = apiData.map(item => item.installed_capacity_2024);
//   const investment_electrolyser_growth = apiData.map(item => item.installed_capacity_2024);
//   const r_n_d_growth = apiData.map(item => item.r_and_d_gh_production_total);
//   const upcoming_project_growth = apiData.map(item => item.project_score);



//   const handleExport = () => {
//     const table = tableRef.current;
//     const wb = XLSX.utils.table_to_book(table, { sheet: "GH Scores" });
//     const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     saveAs(new Blob([wbout], { type: "application/octet-stream" }), "GH_Scores.xlsx");
//   };

//   return (
//     <div className="table-box">
//       <button
//         onClick={handleExport } className="export-btn"
        
//       >
//         Export to Excel
//       </button>
//       <table ref={tableRef} className="min-w-full border border-gray-300 shadow-md rounded-lg">
//         <thead className="bg-blue-600 text-white">
//           <tr>
//             <th className="border px-3 py-2 cursor-pointer">S.No.</th>
//             <th className="border px-3 py-2 cursor-pointer">Evaluation Parameters</th>
//             <th className="border px-3 py-2 cursor-pointer">Max Score</th>
//             <th className="border px-3 py-2 cursor-pointer">Sub KPI Score</th>
//             <th className="border px-3 py-2 cursor-pointer">Unit of Eval</th>
          
//             {companies.map((company) => (
//               <th key={company} className="border px-3 py-2 cursor-pointer">
//                 {company}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody className="bg-white">
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1</td>
//             <td className="border px-3 py-2">
//               <strong>Installed Capacity of Green hydrogen production units</strong>
//             </td>
//             <td className="border px-3 py-2">35</td>
//             <td className="border px-3 py-2">35</td>
//             <td className="border px-3 py-2"></td>
           
//             {installed_capacity_growth.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.1</td>
//             <td className="border px-3 py-2">
//               Installed Capacity of Green hydrogen production units (MT)
//             </td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">10</td>
//             <td className="border px-3 py-2">MT</td>
          
//             {installed_capacity.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//         <strong>Installed Capacity of Green hydrogen production units (MT) Score</strong>
//        </td>

//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {installed_capacity_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.2</td>
//             <td className="border px-3 py-2">
//               Production of Green hydrogen (MT)
//             </td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">10</td>
//             <td className="border px-3 py-2">MT</td>
           
//             {production_MT.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Production of Green hydrogen (MT) Score</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {production_MT_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.3</td>
//             <td className="border px-3 py-2">
//               Carbon emitted per unit of Green Hydrogen Production (Tonne/ Tonne)
//             </td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2">Number</td>
          
//             {carbon_emitted.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Carbon emitted per unit of Green Hydrogen Production (Tonne/ Tonne) Score</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
            
//                         {carbon_emitted_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.4</td>
//             <td className="border px-3 py-2">
//               Purity of Green Hydrogen Produced (%)
//             </td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2">%</td>
         
//             {purity.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Purity of Green Hydrogen Produced (%) Score</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
          
//                        {purity_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.5</td>
//             <td className="border px-3 py-2">Cost of Production (INR / Tonne)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2">%</td>
           
//             {cost_production.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Cost of Production (INR / Tonne) Score</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//                         {cost_production_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">2</td>
//             <td className="border px-3 py-2"><strong>Investment in Green Hydrogen</strong></td>
//             <td className="border px-3 py-2">20</td>
//             <td className="border px-3 py-2">20</td>
//             <td className="border px-3 py-2"></td>
           
//             {investment_growth.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {/* {safeFmt(v, 2)} */}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">2.1</td>
//             <td className="border px-3 py-2">
//               Investment in Green Hydrogen production/transportation/distribution/storage (INR Crore)
//             </td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">10</td>
//             <td className="border px-3 py-2">Number</td>
          
//             {investment_production.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {/* {safeFmt(v, 2)} */}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong> Investment in Green Hydrogen production/transportation/distribution/storage (INR Crore) Score</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
         
//           {investment_production.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {/* {safeFmt(v, 2)} */}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">2.2</td>
//             <td className="border px-3 py-2">
//               Growth (%) in investment in Green Hydrogen production/transportation/distribution/storage
//             </td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">10</td>
//             <td className="border px-3 py-2">%</td>
           
//             {growth_investment_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">in 2024-25 (INR Crore)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
          
//             {growth_investment_2024.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">in 2023-24 (INR Crore)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
          
//             {growth_investment_2023.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">3</td>
//             <td className="border px-3 py-2">
//              <strong> Investment in Electrolyser/ Membrane Manufacturing</strong>
//             </td>
//             <td className="border px-3 py-2">10</td>
//             <td className="border px-3 py-2">10</td>
//             <td className="border px-3 py-2"></td>
           
//             {investment_electrolyser_growth.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {/* {safeFmt(v, 2)} */}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">3.1</td>
//             <td className="border px-3 py-2">
//               Investment in Electrolyser/ Membrane Manufacturing (INR Crore)
//             </td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2">Number</td>
           
//             {investment_electrolyser.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Investment in Electrolyser/ Membrane Manufacturing (INR Crore) Score</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
          
//             {investment_electrolyser_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {/* {safeFmt(v, 2)} */}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">3.2</td>
//             <td className="border px-3 py-2">
//               Growth (%) in investment in Electrolyser / Membrane Manufacturing
//             </td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2">%</td>
           
//             {growth_electrolyser.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong> Growth (%) in investment in Electrolyser / Membrane Manufacturing Score</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {growth_electrolyser_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {/* {safeFmt(v, 2)} */}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">4</td>
//             <td className="border px-3 py-2">
//              <strong> R&D in Green Hydrogen production/ transportation/distribution/ storage areas</strong>
//             </td>
//             <td className="border px-3 py-2">15</td>
//             <td className="border px-3 py-2">15</td>
//             <td className="border px-3 py-2"></td>
           
//             {r_n_d_growth.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">4.1</td>
//             <td className="border px-3 py-2">
//               Patents filed in the Assessment year
//             </td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">3</td>
//             <td className="border px-3 py-2">Number</td>
          
//             {patent_filed.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Patents filed in the Assessment year Score</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//                        {patent_filed_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">4.2</td>
//             <td className="border px-3 py-2">Total Patents Granted (National)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">3</td>
//             <td className="border px-3 py-2">Number</td>
          
//             {patent_national.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Total Patents Granted (National) Score</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//                         {patent_national_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">4.3</td>
//             <td className="border px-3 py-2">
//               Total Patents Granted (International)
//             </td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">4</td>
//             <td className="border px-3 py-2">Number</td>
           
//             {patent_international.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong> Total Patents Granted (International) Score</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//              {patent_international_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">4.4</td>
//             <td className="border px-3 py-2">Patents Commercialized</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2">Number</td>
           
//             {patent_commercial.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Patents Commercialized Score</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//                        {patent_commercial_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"><strong>Upcoming Projects</strong></td>
//             <td className="border px-3 py-2">20</td>
//             <td className="border px-3 py-2">20</td>
//             <td className="border px-3 py-2"></td>
           
//             {upcoming_project_growth.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {/* {safeFmt(v, 2)} */}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">5.1</td>
//             <td className="border px-3 py-2">Project Capacity - Schedule (B/A)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">10</td>
//             <td className="border px-3 py-2">Number</td>
           
//             {companies.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
                
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">Formula: (B/A)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {project_formula.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {/* {safeFmt(v, 2)} */}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">
//               Completed Year: (Project Completion Year - Current Year) - (B)
//             </td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {project_completed_year.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {/* {safeFmt(v, 2)} */}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">Project Completion year</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {project_completion_year.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {/* {safeFmt(v, 2)} */}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">Capacity - (A)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>

//             {project_capacity.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {/* {safeFmt(v, 2)} */}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">5.2</td>
//             <td className="border px-3 py-2"><strong>Project Size - Progress Status</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">10</td>

//             <td className="border px-3 py-2"></td>
            
//             {project_status.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {/* {safeFmt(v, 2)} */}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Grand Total</strong></td>
//             <td className="border px-3 py-2">100</td>
//             <td className="border px-3 py-2">100</td>

//             <td className="border px-3 py-2"></td>
            
//             {Total_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {/* {safeFmt(v, 2)} */}
//               </td>
//             ))}
//           </tr>
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default GHscoretable;



// import React, { useRef, useState, useEffect } from "react";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import apiClient from "../../api/axiosClient";
// import "../../styles/scoretable.css";

// const ENDPOINT = "/green-hydrogen-scores/";

// const GHscoretable = () => {
//   const tableRef = useRef();
//   const [apiData, setApiData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const currentYear = 2025;

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await apiClient.get(ENDPOINT);
//         setApiData(response.data.results || []);
//         setLoading(false);
//       } catch (err) {
//         console.error("API error:", err);
//         setError("Failed to fetch data from API");
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   if (loading) return <div>Loading...</div>;
//   if (error) return <div>{error}</div>;
//   if (!apiData.length) return <div>No data available</div>;

//   // Data mappings for UI display (using API-provided scores or raw data)
//   const companies = apiData.map((item) => item.organisation_name || "Unknown");
//   const installed_capacity = apiData.map((item) => item.installed_capacity_2024 || 0);
//   const installed_capacity_score = apiData.map((item) => item.installed_capacity_2024_score || 0);
//   const production_MT = apiData.map((item) => item.production_2024 || 0);
//   const production_MT_score = apiData.map((item) => item.production_2024_score || 0);
//   const carbon_emitted = apiData.map((item) => item.carbon_emission_2024 || 0);
//   const carbon_emitted_score = apiData.map((item) => item.carbon_emission_2024_score || 0);
//   const purity = apiData.map((item) => item.purity_2024 || 0);
//   const purity_score = apiData.map((item) => item.purity_2024_score || 0);
//   const cost_production = apiData.map((item) => item.cost_of_production_2024 || 0);
//   const cost_production_score = apiData.map((item) => item.cost_of_production_2024_score || 0);
//   const investment_activities_raw = apiData.map((item) => item.investment_activities_2024 || 0);
//   const investment_production_score = apiData.map((item) => item.investment_activities_2024_score || 0);
//   const growth_investment_2024 = apiData.map((item) => item.investment_activities_2024 || 0);
//   const growth_investment_2023 = apiData.map((item) => item.investment_activities_2023 || 0);
//   const growth_investment_score = apiData.map((item) => item.growth_invest_gh_score_percent || 0);
//   const investment_electrolyser_raw = apiData.map((item) => item.investment_electrolyser_2024 || 0);
//   const investment_electrolyser_score = apiData.map((item) => item.investment_electrolyser_2024_score || 0);
//   const investment_electrolyser_2023 = apiData.map((item) => item.investment_electrolyser_2023 || 0);
//   const growth_electrolyser_score = apiData.map((item) => item.growth_electrolyser_score || 0);
//   const patent_filed = apiData.map((item) => item.patents_filed_2024 || 0);
//   const patent_filed_score = apiData.map((item) => item.patents_filed_2024_score || 0);
//   const patent_national = apiData.map((item) => item.patents_granted_national_2024 || 0);
//   const patent_national_score = apiData.map((item) => item.patents_granted_national_2024_score || 0);
//   const patent_international = apiData.map((item) => item.patents_granted_international_2024 || 0);
//   const patent_international_score = apiData.map((item) => item.patents_granted_international_2024_score || 0);
//   const patent_commercial = apiData.map((item) => item.patents_commercialized_2024 || 0);
//   const patent_commercial_score = apiData.map((item) => item.patents_commercialized_2024_score || 0);
//   const r_n_d_growth = apiData.map((item) => item.r_and_d_gh_production_total || 0);
//   const upcoming_project_scores_5_1 = apiData.map((item) => item.project_score || 0);
//   const upcoming_project_scores_5_2 = apiData.map(() => 0); // Placeholder, as not provided
//   const project_completion_year = apiData.map((item) => item.project_completion_year_1 || currentYear);
//   const project_capacity = apiData.map((item) => item.capacity_1 || 0);
//   const project_completed_year = project_completion_year.map((y) => Math.max(0, y - currentYear));
//   const project_formula = project_completed_year.map((d, i) =>
//     project_capacity[i] > 0 ? d / project_capacity[i] : 0
//   );
//   const project_status = apiData.map((item) => item.project_current_status_1 || "-");
//   const installed_capacity_growth = installed_capacity_score.map((_, i) =>
//     installed_capacity_score[i] +
//     production_MT_score[i] +
//     carbon_emitted_score[i] +
//     purity_score[i] +
//     cost_production_score[i]
//   );
//   const investment_growth = investment_production_score.map((s, i) => s + growth_investment_score[i]);
//   const investment_electrolyser_growth = investment_electrolyser_score.map((s, i) => s + growth_electrolyser_score[i]);
//   const upcoming_project_growth = upcoming_project_scores_5_1.map((s, i) => s + upcoming_project_scores_5_2[i]);
//   const Total_score = installed_capacity_growth.map((v, i) =>
//     v + investment_growth[i] + investment_electrolyser_growth[i] + r_n_d_growth[i] + upcoming_project_growth[i]
//   );

//   const safeFmt = (v, digits = 2) => {
//     if (v === null || v === undefined || v === "") return "-";
//     if (typeof v === "number" && Number.isFinite(v)) {
//       return digits === 0 ? String(Math.round(v)) : v.toFixed(digits);
//     }
//     const num = Number(v);
//     if (!Number.isNaN(num) && Number.isFinite(num)) {
//       return digits === 0 ? String(Math.round(num)) : num.toFixed(digits);
//     }
//     try {
//       return String(v);
//     } catch {
//       return "-";
//     }
//   };

//   const handleExport = () => {
//     const aoa = [];

//     // Header
//     aoa.push(["", "FIPI Awards 2025 - Green Hydrogen Company of the Year", "", "", "", "", "", "", "", "", "", "", ""]);
//     aoa.push(["", "", "", "", "", "", "", "", "", "", "", "", ""]);
//     aoa.push(["", "", "", "", "", "", "", "", "", "", "", "", ""]);
//     aoa.push(["Sr. No.", "Evaluation Parameters", "Max Score", "Sub KPI Score", "Eval. Method.", "Unit of Eval", "Minimum", "Maximum", ...companies]);

//     // Section 1: Installed Capacity
//     aoa.push([
//       "1",
//       "Installed Capacity of Green hydrogen production units",
//       "35",
//       "35",
//       "",
//       "",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `SUM(I${6}:I${14}:2)`,
//         v: safeFmt(
//           installed_capacity_score[i] +
//             production_MT_score[i] +
//             carbon_emitted_score[i] +
//             purity_score[i] +
//             cost_production_score[i],
//           2
//         ),
//       })),
//       "",
//       "",
//     ]);

//     // 1.1
//     aoa.push([
//       "1.1",
//       "Installed Capacity of Green hydrogen production units (MT)",
//       "",
//       "10",
//       "Highest gets max score",
//       "MT",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `10*I${7}/MAX(I${7}:K${7})`,
//         v: safeFmt(installed_capacity_score[i], 2),
//       })),
//       "",
//       "",
//     ]);
//     aoa.push(["", "", "", "", "", "", "", "", ...installed_capacity.map((v) => safeFmt(v, 2)), "", ""]);

//     // 1.2
//     aoa.push([
//       "1.2",
//       "Production of Green hydrogen (MT)",
//       "",
//       "10",
//       "Highest gets max score",
//       "MT",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `10*I${9}/MAX(I${9}:K${9})`,
//         v: safeFmt(production_MT_score[i], 2),
//       })),
//       "",
//       "",
//     ]);
//     aoa.push(["", "", "", "", "", "", "", "", ...production_MT.map((v) => safeFmt(v, 2)), "", ""]);

//     // 1.3
//     aoa.push([
//       "1.3",
//       "Carbon emitted per unit of Green Hydrogen Production (Tonne/ Tonne)",
//       "",
//       "5",
//       "Lowest gets max score",
//       "Number",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `5*MIN(I${11}:K${11})/I${11}`,
//         v: safeFmt(carbon_emitted_score[i], 2),
//       })),
//       "",
//       "",
//     ]);
//     aoa.push(["", "", "", "", "", "", "", "", ...carbon_emitted.map((v) => safeFmt(v, 2)), "", ""]);

//     // 1.4
//     aoa.push([
//       "1.4",
//       "Purity of Green Hydrogen Produced (%)",
//       "",
//       "5",
//       "Highest gets max score",
//       "%",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `5*I${13}/MAX(I${13}:K${13})`,
//         v: safeFmt(purity_score[i], 2),
//       })),
//       "",
//       "",
//     ]);
//     aoa.push(["", "", "", "", "", "", "", "", ...purity.map((v) => safeFmt(v, 2)), "", ""]);

//     // 1.5
//     aoa.push([
//       "1.5",
//       "Cost of Production (INR / Tonne)",
//       "",
//       "5",
//       "Lowest gets max score",
//       "INR/Tonne",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `5*MIN(I${15}:K${15})/I${15}`,
//         v: safeFmt(cost_production_score[i], 2),
//       })),
//       "",
//       "",
//     ]);
//     aoa.push(["", "", "", "", "", "", "", "", ...cost_production.map((v) => safeFmt(v, 2)), "", ""]);

//     // Section 2: Investment in Green Hydrogen
//     aoa.push([
//       "2",
//       "Investment in Green Hydrogen",
//       "20",
//       "20",
//       "",
//       "",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `SUM(I${17}:I${19})`,
//         v: safeFmt(investment_production_score[i] + growth_investment_score[i], 2),
//       })),
//       "",
//       "",
//     ]);

//     // 2.1
//     aoa.push([
//       "2.1",
//       "Investment in Green Hydrogen production/transportation/distribution/storage (INR Crores)",
//       "",
//       "10",
//       "Highest gets max score",
//       "Number",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `10*I${18}/MAX(I${18}:K${18})`,
//         v: safeFmt(investment_production_score[i], 2),
//       })),
//       "",
//       "",
//     ]);
//     aoa.push(["", "", "", "", "", "", "", "", ...investment_activities_raw.map((v) => safeFmt(v, 2)), "", ""]);

//     // 2.2
//     aoa.push([
//       "2.2",
//       "Growth (%) in investment in Green Hydrogen production/transportation/distribution/storage",
//       "",
//       "10",
//       "Highest gets max score",
//       "%",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `10*IF(I${21}=0,0,(I${20}-I${21})/I${21})/MAX(IF(I${21}=0,0,(I${20}-I${21})/I${21}),IF(J${21}=0,0,(J${20}-J${21})/J${21}),IF(K${21}=0,0,(K${20}-K${21})/K${21}))`,
//         v: safeFmt(growth_investment_score[i], 2),
//       })),
//       "",
//       "",
//     ]);
//     aoa.push(["", "in 2024-25 (INR Crores)", "", "", "", "", "", "", ...growth_investment_2024.map((v) => safeFmt(v, 2)), "", ""]);
//     aoa.push(["", "in 2023-24 (INR Crores)", "", "", "", "", "", "", ...growth_investment_2023.map((v) => safeFmt(v, 2)), "", ""]);

//     // Section 3: Investment in Electrolyser
//     aoa.push([
//       "3",
//       "Investment in Electrolyser/ Membrane Manufacturing",
//       "10",
//       "10",
//       "",
//       "",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `SUM(I${24}:I${26})`,
//         v: safeFmt(investment_electrolyser_score[i] + growth_electrolyser_score[i], 2),
//       })),
//       "",
//       "",
//     ]);

//     // 3.1
//     aoa.push([
//       "3.1",
//       "Investment in Electrolyser/ Membrane Manufacturing (INR Crores)",
//       "",
//       "5",
//       "Highest gets max score",
//       "Number",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `5*I${25}/MAX(I${25}:K${25})`,
//         v: safeFmt(investment_electrolyser_score[i], 2),
//       })),
//       "",
//       "",
//     ]);
//     aoa.push(["", "", "", "", "", "", "", "", ...investment_electrolyser_raw.map((v) => safeFmt(v, 2)), "", ""]);

//     // 3.2
//     aoa.push([
//       "3.2",
//       "Growth (%) in investment in Electrolyser / Membrane Manufacturing",
//       "",
//       "5",
//       "Highest gets max score",
//       "%",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `5*IF(I${28}=0,0,(I${27}-I${28})/I${28})/MAX(IF(I${28}=0,0,(I${27}-I${28})/I${28}),IF(J${28}=0,0,(J${27}-J${28})/J${28}),IF(K${28}=0,0,(K${27}-K${28})/K${28}))`,
//         v: safeFmt(growth_electrolyser_score[i], 2),
//       })),
//       "",
//       "",
//     ]);
//     aoa.push(["", "in 2024-25 (INR Crores)", "", "", "", "", "", "", ...investment_electrolyser_raw.map((v) => safeFmt(v, 2)), "", ""]);
//     aoa.push(["", "in 2023-24 (INR Crores)", "", "", "", "", "", "", ...investment_electrolyser_2023.map((v) => safeFmt(v, 2)), "", ""]);

//     // Section 4: R&D
//     aoa.push([
//       "4",
//       "R&D in Green Hydrogen production/ transportation/distribution/ storage areas",
//       "15",
//       "15",
//       "",
//       "",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `SUM(I${30}:I${36}:2)`,
//         v: safeFmt(r_n_d_growth[i], 2),
//       })),
//       "",
//       "",
//     ]);

//     // 4.1
//     aoa.push([
//       "4.1",
//       "Patents filed in the Assessment year",
//       "",
//       "3",
//       "Highest gets max score",
//       "Number",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `3*I${31}/MAX(I${31}:K${31})`,
//         v: safeFmt(patent_filed_score[i], 2),
//       })),
//       "",
//       "",
//     ]);
//     aoa.push(["", "", "", "", "", "", "", "", ...patent_filed.map((v) => safeFmt(v, 2)), "", ""]);

//     // 4.2
//     aoa.push([
//       "4.2",
//       "Total Patents Granted (National)",
//       "",
//       "3",
//       "Highest gets max score",
//       "Number",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `3*I${33}/MAX(I${33}:K${33})`,
//         v: safeFmt(patent_national_score[i], 2),
//       })),
//       "",
//       "",
//     ]);
//     aoa.push(["", "", "", "", "", "", "", "", ...patent_national.map((v) => safeFmt(v, 2)), "", ""]);

//     // 4.3
//     aoa.push([
//       "4.3",
//       "Total Patents Granted (International)",
//       "",
//       "4",
//       "Highest gets max score",
//       "Number",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `4*I${35}/MAX(I${35}:K${35})`,
//         v: safeFmt(patent_international_score[i], 2),
//       })),
//       "",
//       "",
//     ]);
//     aoa.push(["", "", "", "", "", "", "", "", ...patent_international.map((v) => safeFmt(v, 2)), "", ""]);

//     // 4.4
//     aoa.push([
//       "4.4",
//       "Patents Commercialized",
//       "",
//       "5",
//       "Highest gets max score",
//       "Number",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `5*I${37}/MAX(I${37}:K${37})`,
//         v: safeFmt(patent_commercial_score[i], 2),
//       })),
//       "",
//       "",
//     ]);
//     aoa.push(["", "", "", "", "", "", "", "", ...patent_commercial.map((v) => safeFmt(v, 2)), "", ""]);

//     // Section 5: Upcoming Projects
//     let five_one_row = aoa.length + 1;
//     aoa.push([
//       "5",
//       "Upcoming Projects",
//       "20",
//       "20",
//       "",
//       "",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `SUM(I${five_one_row + 1},I${five_one_row + 28})`,
//         v: safeFmt(upcoming_project_scores_5_1[i] + upcoming_project_scores_5_2[i], 2),
//       })),
//       "",
//       "",
//     ]);

//     // 5.1
//     aoa.push([
//       "5.1",
//       "Marks obtained against Total Value of all the Upcoming Projects",
//       "",
//       "10",
//       "",
//       "",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `10*I${five_one_row + 2}/MAX(I${five_one_row + 2}:K${five_one_row + 2})`,
//         v: safeFmt(upcoming_project_scores_5_1[i], 2),
//       })),
//       "",
//       "",
//     ]);

//     let total_value_row = aoa.length + 1;
//     aoa.push([
//       "",
//       "Total Value of all the Upcoming Projects",
//       "",
//       "",
//       "",
//       "",
//       "0",
//       "200",
//       ...companies.map(() => ({ v: "" })), // Placeholder, updated later
//       "",
//       "",
//     ]);

//     // Project details
//     let value_rows = [];
//     let project_start_row = aoa.length + 1;
//     for (let j = 1; j <= 5; j++) {
//       aoa.push(["", `Project ${j}`, "", "", "", "", "", "", "", "", "", "", ""]);
//       let capacity_row = aoa.length + 1;
//       aoa.push([
//         "",
//         "Capacity (KT)",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         ...apiData.map((item) => safeFmt(item[`capacity_${j}`] || 0, 2)),
//         "",
//         "",
//       ]);
//       let completion_row = aoa.length + 1;
//       aoa.push([
//         "",
//         "Project Completion Year",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         ...apiData.map((item) => safeFmt(item[`project_completion_year_${j}`] || currentYear, 0)),
//         "",
//         "",
//       ]);
//       let diff_row = aoa.length + 1;
//       aoa.push([
//         "",
//         "Year Difference: (Project Completion Year - 2025)",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         ...companies.map((_, i) => ({
//           f: `I${completion_row}-2025`,
//           v: safeFmt(
//             Math.max(0, (apiData[i][`project_completion_year_${j}`] || currentYear) - currentYear),
//             0
//           ),
//         })),
//         "",
//         "",
//       ]);
//       let marks_row = aoa.length + 1;
//       aoa.push([
//         "",
//         "Marks Allocated to Year Difference",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         ...companies.map((_, i) => ({
//           f: `MAX(0,11-I${diff_row})`,
//           v: safeFmt(
//             Math.max(0, 11 - Math.max(0, (apiData[i][`project_completion_year_${j}`] || currentYear) - currentYear)),
//             0
//           ),
//         })),
//         "",
//         "",
//       ]);
//       let value_row = aoa.length + 1;
//       aoa.push([
//         "",
//         "Project Value: (Marks Allocated to Year Difference * Capacity)",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         ...companies.map((_, i) => ({
//           f: `I${marks_row}*I${capacity_row}`,
//           v: safeFmt(
//             Math.max(0, 11 - Math.max(0, (apiData[i][`project_completion_year_${j}`] || currentYear) - currentYear)) *
//               (apiData[i][`capacity_${j}`] || 0),
//             2
//           ),
//         })),
//         "",
//         "",
//       ]);
//       value_rows.push(value_row);
//     }

//     // Update total value formulas
//     aoa[total_value_row - 1].splice(
//       8,
//       companies.length,
//       ...companies.map((_, i) => ({
//         f: `SUM(I${value_rows.join(",I")})`,
//         v: safeFmt(
//           value_rows.reduce(
//             (sum, row) =>
//               sum +
//               Math.max(
//                 0,
//                 11 - Math.max(0, (apiData[i][`project_completion_year_${value_rows.indexOf(row) + 1}`] || currentYear) - currentYear)
//               ) * (apiData[i][`capacity_${value_rows.indexOf(row) + 1}`] || 0),
//             0
//           ),
//           2
//         ),
//       }))
//     );

//     // 5.2
//     aoa.push([
//       "5.2",
//       "Project Size - Progress Status",
//       "",
//       "10",
//       "",
//       "",
//       "",
//       "",
//       ...companies.map((_, i) => ({ f: "0", v: safeFmt(upcoming_project_scores_5_2[i], 2) })),
//       "",
//       "",
//     ]);

//     // Grand Total
//     aoa.push([
//       "",
//       "Grand Total",
//       "100",
//       "100",
//       "",
//       "",
//       "",
//       "",
//       ...companies.map((_, i) => ({
//         f: `SUM(I${5},I${17},I${24},I${30},I${five_one_row})`,
//         v: safeFmt(Total_score[i], 2),
//       })),
//       "",
//       "",
//     ]);

//     // Notes
//     aoa.push(["", "Notes:", "", "", "", "", "", "", "", "", "", "", ""]);
//     aoa.push(["", "*Areas of Intangible Value", "", "", "", "", "", "", "", "", "", "", ""]);
//     aoa.push(["1", "Reduction Carbon Footprint", "", "", "", "", "", "", "", "", "", "", ""]);
//     aoa.push(["2", "Improvement in Productivity", "", "", "", "", "", "", "", "", "", "", ""]);
//     aoa.push(["3", "Improvement in Energy Efficiency", "", "", "", "", "", "", "", "", "", "", ""]);
//     aoa.push(["4", "Reduction in Usage of Paper", "", "", "", "", "", "", "", "", "", "", ""]);
//     aoa.push(["5", "Expediting procurement/sales invoicing process", "", "", "", "", "", "", "", "", "", "", ""]);
//     aoa.push(["6", "Improvement in HSE Performance", "", "", "", "", "", "", "", "", "", "", ""]);
//     aoa.push(["7", "Improvement in Customer Interfacing", "", "", "", "", "", "", "", "", "", "", ""]);
//     aoa.push(["8", "Others", "", "", "", "", "", "", "", "", "", "", ""]);

//     const sheet = XLSX.utils.aoa_to_sheet(aoa);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, sheet, "Final Output Sheet");
//     const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     saveAs(new Blob([wbout], { type: "application/octet-stream" }), "Green_Hydrogen_Company_of_the_Year_2025.xlsx");
//   };

//   return (
//     <div className="table-box">
//       <button onClick={handleExport} className="export-btn">
//         Export to Excel
//       </button>
//       <table ref={tableRef} className="min-w-full border border-gray-300 shadow-md rounded-lg">
//         <thead className="bg-blue-600 text-white">
//           <tr>
//             <th className="border px-3 py-2 cursor-pointer">Sr. No.</th>
//             <th className="border px-3 py-2 cursor-pointer">Evaluation Parameters</th>
//             <th className="border px-3 py-2 cursor-pointer">Max Score</th>
//             <th className="border px-3 py-2 cursor-pointer">Sub KPI Score</th>
//             <th className="border px-3 py-2 cursor-pointer">Eval. Method.</th>
//             <th className="border px-3 py-2 cursor-pointer">Unit of Eval</th>
//             <th className="border px-3 py-2 cursor-pointer">Minimum</th>
//             <th className="border px-3 py-2 cursor-pointer">Maximum</th>
//             {companies.map((company) => (
//               <th key={company} className="border px-3 py-2 cursor-pointer">
//                 {company}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody className="bg-white">
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1</td>
//             <td className="border px-3 py-2"><strong>Installed Capacity of Green hydrogen production units</strong></td>
//             <td className="border px-3 py-2">35</td>
//             <td className="border px-3 py-2">35</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {installed_capacity_growth.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.1</td>
//             <td className="border px-3 py-2">Installed Capacity of Green hydrogen production units (MT)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">10</td>
//             <td className="border px-3 py-2">Highest gets max score</td>
//             <td className="border px-3 py-2">MT</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {installed_capacity_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Installed Capacity of Green hydrogen production units (MT) Value</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {installed_capacity.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.2</td>
//             <td className="border px-3 py-2">Production of Green hydrogen (MT)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">10</td>
//             <td className="border px-3 py-2">Highest gets max score</td>
//             <td className="border px-3 py-2">MT</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {production_MT_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Production of Green hydrogen (MT) Value</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {production_MT.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.3</td>
//             <td className="border px-3 py-2">Carbon emitted per unit of Green Hydrogen Production (Tonne/ Tonne)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2">Lowest gets max score</td>
//             <td className="border px-3 py-2">Number</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {carbon_emitted_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Carbon emitted per unit of Green Hydrogen Production (Tonne/ Tonne) Value</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {carbon_emitted.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.4</td>
//             <td className="border px-3 py-2">Purity of Green Hydrogen Produced (%)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2">Highest gets max score</td>
//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {purity_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Purity of Green Hydrogen Produced (%) Value</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {purity.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.5</td>
//             <td className="border px-3 py-2">Cost of Production (INR / Tonne)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2">Lowest gets max score</td>
//             <td className="border px-3 py-2">INR/Tonne</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {cost_production_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Cost of Production (INR / Tonne) Value</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {cost_production.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">2</td>
//             <td className="border px-3 py-2"><strong>Investment in Green Hydrogen</strong></td>
//             <td className="border px-3 py-2">20</td>
//             <td className="border px-3 py-2">20</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {investment_growth.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">2.1</td>
//             <td className="border px-3 py-2">Investment in Green Hydrogen production/transportation/distribution/storage (INR Crores)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">10</td>
//             <td className="border px-3 py-2">Highest gets max score</td>
//             <td className="border px-3 py-2">Number</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {investment_production_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Investment in Green Hydrogen production/transportation/distribution/storage (INR Crores) Value</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {investment_activities_raw.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">2.2</td>
//             <td className="border px-3 py-2">Growth (%) in investment in Green Hydrogen production/transportation/distribution/storage</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">10</td>
//             <td className="border px-3 py-2">Highest gets max score</td>
//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {growth_investment_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">in 2024-25 (INR Crores)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {growth_investment_2024.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">in 2023-24 (INR Crores)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {growth_investment_2023.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">3</td>
//             <td className="border px-3 py-2"><strong>Investment in Electrolyser/ Membrane Manufacturing</strong></td>
//             <td className="border px-3 py-2">10</td>
//             <td className="border px-3 py-2">10</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {investment_electrolyser_growth.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">3.1</td>
//             <td className="border px-3 py-2">Investment in Electrolyser/ Membrane Manufacturing (INR Crores)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2">Highest gets max score</td>
//             <td className="border px-3 py-2">Number</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {investment_electrolyser_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Investment in Electrolyser/ Membrane Manufacturing (INR Crores) Value</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {investment_electrolyser_raw.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">3.2</td>
//             <td className="border px-3 py-2">Growth (%) in investment in Electrolyser / Membrane Manufacturing</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2">Highest gets max score</td>
//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {growth_electrolyser_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">in 2024-25 (INR Crores)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {investment_electrolyser_raw.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">in 2023-24 (INR Crores)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {investment_electrolyser_2023.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">4</td>
//             <td className="border px-3 py-2"><strong>R&D in Green Hydrogen production/ transportation/distribution/ storage areas</strong></td>
//             <td className="border px-3 py-2">15</td>
//             <td className="border px-3 py-2">15</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {r_n_d_growth.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">4.1</td>
//             <td className="border px-3 py-2">Patents filed in the Assessment year</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">3</td>
//             <td className="border px-3 py-2">Highest gets max score</td>
//             <td className="border px-3 py-2">Number</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {patent_filed_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Patents filed in the Assessment year Value</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {patent_filed.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">4.2</td>
//             <td className="border px-3 py-2">Total Patents Granted (National)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">3</td>
//             <td className="border px-3 py-2">Highest gets max score</td>
//             <td className="border px-3 py-2">Number</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {patent_national_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Total Patents Granted (National) Value</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {patent_national.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">4.3</td>
//             <td className="border px-3 py-2">Total Patents Granted (International)</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">4</td>
//             <td className="border px-3 py-2">Highest gets max score</td>
//             <td className="border px-3 py-2">Number</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {patent_international_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Total Patents Granted (International) Value</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {patent_international.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">4.4</td>
//             <td className="border px-3 py-2">Patents Commercialized</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2">Highest gets max score</td>
//             <td className="border px-3 py-2">Number</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {patent_commercial_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Patents Commercialized Value</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {patent_commercial.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"><strong>Upcoming Projects</strong></td>
//             <td className="border px-3 py-2">20</td>
//             <td className="border px-3 py-2">20</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {upcoming_project_growth.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">5.1</td>
//             <td className="border px-3 py-2">Marks obtained against Total Value of all the Upcoming Projects</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">10</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {upcoming_project_scores_5_1.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">Total Value of all the Upcoming Projects</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">0</td>
//             <td className="border px-3 py-2">200</td>
//             {apiData.map((item, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(
//                   Array.from({ length: 5 }, (_, j) => j + 1).reduce(
//                     (sum, j) =>
//                       sum +
//                       Math.max(0, 11 - Math.max(0, (item[`project_completion_year_${j}`] || currentYear) - currentYear)) *
//                         (item[`capacity_${j}`] || 0),
//                     0
//                   ),
//                   2
//                 )}
//               </td>
//             ))}
//           </tr>
//           {Array.from({ length: 5 }, (_, j) => j + 1).map((j) => (
//             <React.Fragment key={`project-${j}`}>
//               <tr className="hover:bg-gray-100">
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2">Project {j}</td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 {apiData.map((_, i) => (
//                   <td key={i} className="border px-3 py-2"></td>
//                 ))}
//               </tr>
//               <tr className="hover:bg-gray-100">
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2">Capacity (KT)</td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 {apiData.map((item, i) => (
//                   <td key={i} className="border px-3 py-2">
//                     {safeFmt(item[`capacity_${j}`] || 0, 2)}
//                   </td>
//                 ))}
//               </tr>
//               <tr className="hover:bg-gray-100">
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2">Project Completion Year</td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 {apiData.map((item, i) => (
//                   <td key={i} className="border px-3 py-2">
//                     {safeFmt(item[`project_completion_year_${j}`] || currentYear, 0)}
//                   </td>
//                 ))}
//               </tr>
//               <tr className="hover:bg-gray-100">
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2">Year Difference: (Project Completion Year - {currentYear})</td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 {apiData.map((item, i) => (
//                   <td key={i} className="border px-3 py-2">
//                     {safeFmt(Math.max(0, (item[`project_completion_year_${j}`] || currentYear) - currentYear), 0)}
//                   </td>
//                 ))}
//               </tr>
//               <tr className="hover:bg-gray-100">
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2">Marks Allocated to Year Difference</td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 {apiData.map((item, i) => (
//                   <td key={i} className="border px-3 py-2">
//                     {safeFmt(Math.max(0, 11 - Math.max(0, (item[`project_completion_year_${j}`] || currentYear) - currentYear)), 0)}
//                   </td>
//                 ))}
//               </tr>
//               <tr className="hover:bg-gray-100">
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2">Project Value: (Marks Allocated to Year Difference * Capacity)</td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 <td className="border px-3 py-2"></td>
//                 {apiData.map((item, i) => (
//                   <td key={i} className="border px-3 py-2">
//                     {safeFmt(
//                       Math.max(0, 11 - Math.max(0, (item[`project_completion_year_${j}`] || currentYear) - currentYear)) *
//                         (item[`capacity_${j}`] || 0),
//                       2
//                     )}
//                   </td>
//                 ))}
//               </tr>
//             </React.Fragment>
//           ))}
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">5.2</td>
//             <td className="border px-3 py-2"><strong>Project Size - Progress Status</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">10</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {upcoming_project_scores_5_2.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Grand Total</strong></td>
//             <td className="border px-3 py-2">100</td>
//             <td className="border px-3 py-2">100</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             {Total_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default GHscoretable;




import React, { useRef, useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import apiClient from "../../api/axiosClient";
import "../../styles/scoretable.css";

const ENDPOINT = "/vw-hrm-scores/"; // Adjust to the correct endpoint for Green Hydrogen data

const GHscoretable = () => {
  const tableRef = useRef();
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const currentYear = 2025;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiClient.get(ENDPOINT);
        setApiData(response.data.results || []);
        setLoading(false);
      } catch (err) {
        console.error("API error:", err);
        setError("Failed to fetch data from API");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  // Map API data to arrays
   const companies = apiData.map(item => item.organisation_name);
  const installed_capacity = apiData.map(item => item.installed_capacity_2024);
  const installed_capacity_score = apiData.map(item => item.installed_capacity_2024_score);
  const production_MT =apiData.map(item => item.production_2024);
  const production_MT_score = apiData.map(item => item.production_2024_score);
  const carbon_emitted = apiData.map(item => item.carbon_emission_2024);
  const carbon_emitted_score = apiData.map(item => item.carbon_emission_2024_score);
  const purity = apiData.map(item => item.purity_2024);
  const purity_score = apiData.map(item => item.purity_2024_score);
  const cost_production = apiData.map(item => item.cost_of_production_2024);
  const cost_production_score = apiData.map(item => item.cost_of_production_2024_score);
  const investment_production = apiData.map(item => item.installed_capacity_2024);
  const investment_production_score = apiData.map(item => item.installed_capacity_2024);
  const growth_investment_2024 = apiData.map(item => item.investment_activities_2024);
  const growth_investment_score = apiData.map(item => item.growth_invest_gh_score_percent);
  const growth_investment_2023 = apiData.map(item => item.investment_activities_2023);
  const investment_electrolyser = apiData.map(item => item.investment_electrolyser_2024);
  const investment_electrolyser_score = apiData.map(item => item.installed_capacity_2024);
  const growth_electrolyser = apiData.map(item => item.installed_capacity_2024);
  const growth_electrolyser_score = apiData.map(item => item.installed_capacity_2024);
  const patent_filed = apiData.map(item => item.patents_filed_2024);
  const patent_filed_score = apiData.map(item => item.patents_filed_2024_score);
  const patent_national = apiData.map(item => item.patents_granted_national_2024);
  const patent_national_score = apiData.map(item => item.patents_granted_national_2024_score);
  const patent_international = apiData.map(item => item.patents_granted_international_2024);
  const patent_international_score = apiData.map(item => item.patents_granted_international_2024_score);
  const patent_commercial = apiData.map(item => item.patents_commercialized_2024);
  const patent_commercial_score = apiData.map(item => item.patents_commercialized_2024_score);
  const project_formula = apiData.map(item => item.installed_capacity_2024);
  const project_completed_year = apiData.map(item => item.installed_capacity_2024);
  const project_completion_year = apiData.map(item => item.installed_capacity_2024);
  const project_capacity = apiData.map(item => item.installed_capacity_2024);
  const project_status =apiData.map(item => item.installed_capacity_2024);
  const Total_score = apiData.map(item => item.installed_capacity_2024);
  const installed_capacity_growth = apiData.map(item => item.installed_capacity_gh_p_unit);
  const investment_growth = apiData.map(item => item.installed_capacity_2024);
  const investment_electrolyser_growth = apiData.map(item => item.installed_capacity_2024);
  const r_n_d_growth = apiData.map(item => item.r_and_d_gh_production_total);
  const upcoming_project_growth = apiData.map(item => item.project_score);


  const safeFmt = (v, digits = 2) => {
    if (v === null || v === undefined || v === "") return "-";
    if (typeof v === "number" && Number.isFinite(v)) {
      return digits === 0 ? String(Math.round(v)) : v.toFixed(digits);
    }
    const num = Number(v);
    if (!Number.isNaN(num) && Number.isFinite(num)) {
      return digits === 0 ? String(Math.round(num)) : num.toFixed(digits);
    }
    try {
      return String(v);
    } catch {
      return "-";
    }
  };

  const handleExport = () => {
    const aoa = [];

    // Header
    aoa.push(["", "FIPI Awards 2025 - Green Hydrogen Company of the Year", "", "", "", "", "", "", ...Array(companies.length).fill("")]);
    aoa.push(["", "", "", "", "", "", "", "", ...Array(companies.length).fill("")]);
    aoa.push(["", "", "", "", "", "", "", "", ...Array(companies.length).fill("")]);
    aoa.push([
      "Sr. No.",
      "Evaluation Parameters",
      "Max Score",
      "Sub KPI Score",
      "Eval. Method.",
      "Unit of Eval",
      "Minimum",
      "Maximum",
      ...companies,
    ]);

    // Helper to generate column letter (I, J, K, etc.)
    const getColumnLetter = index => String.fromCharCode(73 + index); // 73 = 'I'

    // Section 1: Installed Capacity
    aoa.push([
      "1",
      "Installed Capacity of Green hydrogen production units",
      "35",
      "35",
      "",
      "",
      "",
      "",
      ...Total_score.map((_, i) => ({
        f: `SUM(${getColumnLetter(i)}6:${getColumnLetter(i)}14:2)`,
        v: installed_capacity_growth[i],
      })),
    ]);

    // 1.1
    aoa.push([
      "1.1",
      "Installed Capacity of Green hydrogen production units (MT)",
      "",
      "10",
      "Highest gets max score",
      "MT",
      "",
      "",
      ...installed_capacity_score.map((v, i) => ({
        f: `10*${getColumnLetter(i)}7/MAX(${getColumnLetter(0)}7:${getColumnLetter(companies.length - 1)}7)`,
        v,
      })),
    ]);
    aoa.push(["", "", "", "", "", "", "", "", ...installed_capacity]);

    // 1.2
    aoa.push([
      "1.2",
      "Production of Green hydrogen (MT)",
      "",
      "10",
      "Highest gets max score",
      "MT",
      "",
      "",
      ...production_MT_score.map((v, i) => ({
        f: `10*${getColumnLetter(i)}9/MAX(${getColumnLetter(0)}9:${getColumnLetter(companies.length - 1)}9)`,
        v,
      })),
    ]);
    aoa.push(["", "", "", "", "", "", "", "", ...production_MT]);

    // 1.3
    aoa.push([
      "1.3",
      "Carbon emitted per unit of Green Hydrogen Production (Tonne/ Tonne)",
      "",
      "5",
      "Lowest gets max score",
      "Number",
      "",
      "",
      ...carbon_emitted_score.map((v, i) => ({
        f: `5*MIN(${getColumnLetter(0)}11:${getColumnLetter(companies.length - 1)}11)/${getColumnLetter(i)}11`,
        v,
      })),
    ]);
    aoa.push(["", "", "", "", "", "", "", "", ...carbon_emitted]);

    // 1.4
    aoa.push([
      "1.4",
      "Purity of Green Hydrogen Produced (%)",
      "",
      "5",
      "Highest gets max score",
      "%",
      "",
      "",
      ...purity_score.map((v, i) => ({
        f: `5*${getColumnLetter(i)}13/MAX(${getColumnLetter(0)}13:${getColumnLetter(companies.length - 1)}13)`,
        v,
      })),
    ]);
    aoa.push(["", "", "", "", "", "", "", "", ...purity]);

    // 1.5
    aoa.push([
      "1.5",
      "Cost of Production (INR / Tonne)",
      "",
      "5",
      "Lowest gets max score",
      "INR/Tonne",
      "",
      "",
      ...cost_production_score.map((v, i) => ({
        f: `5*MIN(${getColumnLetter(0)}15:${getColumnLetter(companies.length - 1)}15)/${getColumnLetter(i)}15`,
        v,
      })),
    ]);
    aoa.push(["", "", "", "", "", "", "", "", ...cost_production]);

    // Section 2: Investment in Green Hydrogen
    aoa.push([
      "2",
      "Investment in Green Hydrogen",
      "20",
      "20",
      "",
      "",
      "",
      "",
      ...investment_growth.map((v, i) => ({
        f: `SUM(${getColumnLetter(i)}17:${getColumnLetter(i)}19)`,
        v,
      })),
    ]);

    // 2.1
    aoa.push([
      "2.1",
      "Investment in Green Hydrogen production/transportation/distribution/storage (INR Crores)",
      "",
      "10",
      "Highest gets max score",
      "Number",
      "",
      "",
      ...investment_production_score.map((v, i) => ({
        f: `10*${getColumnLetter(i)}18/MAX(${getColumnLetter(0)}18:${getColumnLetter(companies.length - 1)}18)`,
        v,
      })),
    ]);
    aoa.push(["", "", "", "", "", "", "", "", ...installed_capacity]);

    // 2.2
    aoa.push([
      "2.2",
      "Growth (%) in investment in Green Hydrogen production/transportation/distribution/storage",
      "",
      "10",
      "Highest gets max score",
      "%",
      "",
      "",
      ...growth_investment_score.map((v, i) => ({
        f: `10*IF(${getColumnLetter(i)}21=0,0,(${getColumnLetter(i)}20-${getColumnLetter(i)}21)/${getColumnLetter(i)}21)/MAX(${Array.from(
          { length: companies.length },
          (_, j) => `IF(${getColumnLetter(j)}21=0,0,(${getColumnLetter(j)}20-${getColumnLetter(j)}21)/${getColumnLetter(j)}21)`
        ).join(",")})`,
        v,
      })),
    ]);
    aoa.push(["", "in 2024-25 (INR Crores)", "", "", "", "", "", "", ...growth_investment_2024]);
    aoa.push(["", "in 2023-24 (INR Crores)", "", "", "", "", "", "", ...growth_investment_2023]);

    // Section 3: Investment in Electrolyser
    aoa.push([
      "3",
      "Investment in Electrolyser/ Membrane Manufacturing",
      "10",
      "10",
      "",
      "",
      "",
      "",
      ...investment_electrolyser_growth.map((v, i) => ({
        f: `SUM(${getColumnLetter(i)}24:${getColumnLetter(i)}26)`,
        v,
      })),
    ]);

    // 3.1
    aoa.push([
      "3.1",
      "Investment in Electrolyser/ Membrane Manufacturing (INR Crores)",
      "",
      "5",
      "Highest gets max score",
      "Number",
      "",
      "",
      ...investment_electrolyser_score.map((v, i) => ({
        f: `5*${getColumnLetter(i)}25/MAX(${getColumnLetter(0)}25:${getColumnLetter(companies.length - 1)}25)`,
        v,
      })),
    ]);
    aoa.push(["", "", "", "", "", "", "", "", ...installed_capacity]);

    // 3.2
    aoa.push([
      "3.2",
      "Growth (%) in investment in Electrolyser / Membrane Manufacturing",
      "",
      "5",
      "Highest gets max score",
      "%",
      "",
      "",
      ...growth_electrolyser_score.map((v, i) => ({
        f: `5*IF(${getColumnLetter(i)}28=0,0,(${getColumnLetter(i)}27-${getColumnLetter(i)}28)/${getColumnLetter(i)}28)/MAX(${Array.from(
          { length: companies.length },
          (_, j) => `IF(${getColumnLetter(j)}28=0,0,(${getColumnLetter(j)}27-${getColumnLetter(j)}28)/${getColumnLetter(j)}28)`
        ).join(",")})`,
        v,
      })),
    ]);
    aoa.push(["", "in 2024-25 (INR Crores)", "", "", "", "", "", "", ...installed_capacity]);
    aoa.push(["", "in 2023-24 (INR Crores)", "", "", "", "", "", "", ...installed_capacity]);

    // Section 4: R&D
    aoa.push([
      "4",
      "R&D in Green Hydrogen production/ transportation/distribution/ storage areas",
      "15",
      "15",
      "",
      "",
      "",
      "",
      ...r_n_d_growth.map((v, i) => ({
        f: `SUM(${getColumnLetter(i)}30:${getColumnLetter(i)}36:2)`,
        v,
      })),
    ]);

    // 4.1
    aoa.push([
      "4.1",
      "Patents filed in the Assessment year",
      "",
      "3",
      "Highest gets max score",
      "Number",
      "",
      "",
      ...patent_filed_score.map((v, i) => ({
        f: `3*${getColumnLetter(i)}31/MAX(${getColumnLetter(0)}31:${getColumnLetter(companies.length - 1)}31)`,
        v,
      })),
    ]);
    aoa.push(["", "", "", "", "", "", "", "", ...patent_filed]);

    // 4.2
    aoa.push([
      "4.2",
      "Total Patents Granted (National)",
      "",
      "3",
      "Highest gets max score",
      "Number",
      "",
      "",
      ...patent_national_score.map((v, i) => ({
        f: `3*${getColumnLetter(i)}33/MAX(${getColumnLetter(0)}33:${getColumnLetter(companies.length - 1)}33)`,
        v,
      })),
    ]);
    aoa.push(["", "", "", "", "", "", "", "", ...patent_national]);

    // 4.3
    aoa.push([
      "4.3",
      "Total Patents Granted (International)",
      "",
      "4",
      "Highest gets max score",
      "Number",
      "",
      "",
      ...patent_international_score.map((v, i) => ({
        f: `4*${getColumnLetter(i)}35/MAX(${getColumnLetter(0)}35:${getColumnLetter(companies.length - 1)}35)`,
        v,
      })),
    ]);
    aoa.push(["", "", "", "", "", "", "", "", ...patent_international]);

    // 4.4
    aoa.push([
      "4.4",
      "Patents Commercialized",
      "",
      "5",
      "Highest gets max score",
      "Number",
      "",
      "",
      ...patent_commercial_score.map((v, i) => ({
        f: `5*${getColumnLetter(i)}37/MAX(${getColumnLetter(0)}37:${getColumnLetter(companies.length - 1)}37)`,
        v,
      })),
    ]);
    aoa.push(["", "", "", "", "", "", "", "", ...patent_commercial]);

    // Section 5: Upcoming Projects
    let five_one_row = aoa.length + 1;
    aoa.push([
      "5",
      "Upcoming Projects",
      "20",
      "20",
      "",
      "",
      "",
      "",
      ...upcoming_project_growth.map((v, i) => ({
        f: `SUM(${getColumnLetter(i)}${five_one_row}:${getColumnLetter(i)}${five_one_row + 30}:2)`,
        v,
      })),
    ]);

    // 5.1
    aoa.push([
      "5.1",
      "Marks obtained against Total Value of all the Upcoming Projects",
      "",
      "10",
      "",
      "",
      "",
      "",
      ...installed_capacity.map((v, i) => ({
        f: `10*${getColumnLetter(i)}${five_one_row + 2}/MAX(${getColumnLetter(0)}${five_one_row + 2}:${getColumnLetter(companies.length - 1)}${five_one_row + 2})`,
        v,
      })),
    ]);

    let total_value_row = aoa.length + 1;
    aoa.push([
      "",
      "Total Value of all the Upcoming Projects",
      "",
      "",
      "",
      "",
      "0",
      "200",
      ...installed_capacity.map(v => ({ v })),
    ]);

    // Project details
    let value_rows = [];
    for (let j = 1; j <= 5; j++) {
      aoa.push(["", `Project ${j}`, "", "", "", "", "", "", ...Array(companies.length).fill("")]);
      let capacity_row = aoa.length + 1;
      aoa.push([
        "",
        "Capacity (KT)",
        "",
        "",
        "",
        "",
        "",
        "",
        ...apiData.map(item => item[`capacity_${j}`] || 0),
      ]);
      let completion_row = aoa.length + 1;
      aoa.push([
        "",
        "Project Completion Year",
        "",
        "",
        "",
        "",
        "",
        "",
        ...apiData.map(item => item[`project_completion_year_${j}`] || 0),
      ]);
      let diff_row = aoa.length + 1;
      aoa.push([
        "",
        "Year Difference: (Project Completion Year - 2025)",
        "",
        "",
        "",
        "",
        "",
        "",
        ...apiData.map((item, i) => ({
          f: `${getColumnLetter(i)}${completion_row}-2025`,
          v: Math.max(0, (item[`project_completion_year_${j}`] || 0) - currentYear),
        })),
      ]);
      let marks_row = aoa.length + 1;
      aoa.push([
        "",
        "Marks Allocated to Year Difference",
        "",
        "",
        "",
        "",
        "",
        "",
        ...apiData.map((item, i) => ({
          f: `MAX(0,11-${getColumnLetter(i)}${diff_row})`,
          v: Math.max(0, 11 - Math.max(0, (item[`project_completion_year_${j}`] || 0) - currentYear)),
        })),
      ]);
      let value_row = aoa.length + 1;
      aoa.push([
        "",
        "Project Value: (Marks Allocated to Year Difference * Capacity)",
        "",
        "",
        "",
        "",
        "",
        "",
        ...apiData.map((item, i) => ({
          f: `${getColumnLetter(i)}${marks_row}*${getColumnLetter(i)}${capacity_row}`,
          v: Math.max(0, 11 - Math.max(0, (item[`project_completion_year_${j}`] || 0) - currentYear)) * (item[`capacity_${j}`] || 0),
        })),
      ]);
      value_rows.push(value_row);
    }

    // Update total value formulas
    aoa[total_value_row - 1][8] = {
      f: `SUM(${value_rows.map(row => `${getColumnLetter(0)}${row}`).join(",")})`,
      v: installed_capacity[0],
    };
    for (let i = 1; i < companies.length; i++) {
      aoa[total_value_row - 1][8 + i] = {
        f: `SUM(${value_rows.map(row => `${getColumnLetter(i)}${row}`).join(",")})`,
        v: installed_capacity[i],
      };
    }

    // 5.2
    aoa.push([
      "5.2",
      "Project Size - Progress Status",
      "",
      "10",
      "",
      "",
      "",
      "",
      ...installed_capacity.map(v => ({ f: "0", v })),
    ]);

    // Grand Total
    aoa.push([
      "",
      "Grand Total",
      "100",
      "100",
      "",
      "",
      "",
      "",
      ...Total_score.map((v, i) => ({
        f: `SUM(${getColumnLetter(i)}5,${getColumnLetter(i)}16,${getColumnLetter(i)}23,${getColumnLetter(i)}28,${getColumnLetter(i)}39)`,
        v,
      })),
    ]);

    // Notes
    aoa.push(["", "Notes:", "", "", "", "", "", "", ...Array(companies.length).fill("")]);
    aoa.push(["", "*Areas of Intangible Value", "", "", "", "", "", "", ...Array(companies.length).fill("")]);
    aoa.push(["1", "Reduction Carbon Footprint", "", "", "", "", "", "", ...Array(companies.length).fill("")]);
    aoa.push(["2", "Improvement in Productivity", "", "", "", "", "", "", ...Array(companies.length).fill("")]);
    aoa.push(["3", "Improvement in Energy Efficiency", "", "", "", "", "", "", ...Array(companies.length).fill("")]);
    aoa.push(["4", "Reduction in Usage of Paper", "", "", "", "", "", "", ...Array(companies.length).fill("")]);
    aoa.push(["5", "Expediting procurement/sales invoicing process", "", "", "", "", "", "", ...Array(companies.length).fill("")]);
    aoa.push(["6", "Improvement in HSE Performance", "", "", "", "", "", "", ...Array(companies.length).fill("")]);
    aoa.push(["7", "Improvement in Customer Interfacing", "", "", "", "", "", "", ...Array(companies.length).fill("")]);
    aoa.push(["8", "Others", "", "", "", "", "", "", ...Array(companies.length).fill("")]);

    const sheet = XLSX.utils.aoa_to_sheet(aoa);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, sheet, "Final Output Sheet");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "Green_Hydrogen_Company_of_the_Year_2025.xlsx");
  };

  return (
    <div className="table-box">
      <button onClick={handleExport} className="export-btn">
        Export to Excel
      </button>
      <table ref={tableRef} className="min-w-full border border-gray-300 shadow-md rounded-lg">
        <thead className="bg-blue-600 text-white">
          <tr>
            <th className="border px-3 py-2 cursor-pointer">Sr. No.</th>
            <th className="border px-3 py-2 cursor-pointer">Evaluation Parameters</th>
            <th className="border px-3 py-2 cursor-pointer">Max Score</th>
            <th className="border px-3 py-2 cursor-pointer">Sub KPI Score</th>
            <th className="border px-3 py-2 cursor-pointer">Eval. Method.</th>
            <th className="border px-3 py-2 cursor-pointer">Unit of Eval</th>
            <th className="border px-3 py-2 cursor-pointer">Minimum</th>
            <th className="border px-3 py-2 cursor-pointer">Maximum</th>
            {companies.map((company) => (
              <th key={company} className="border px-3 py-2 cursor-pointer">
                {company}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white">
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1</td>
            <td className="border px-3 py-2"><strong>Installed Capacity of Green hydrogen production units</strong></td>
            <td className="border px-3 py-2">35</td>
            <td className="border px-3 py-2">35</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {installed_capacity_growth.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.1</td>
            <td className="border px-3 py-2">Installed Capacity of Green hydrogen production units (MT)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2">Highest gets max score</td>
            <td className="border px-3 py-2">MT</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {installed_capacity_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Installed Capacity of Green hydrogen production units (MT) Value</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {installed_capacity.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.2</td>
            <td className="border px-3 py-2">Production of Green hydrogen (MT)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2">Highest gets max score</td>
            <td className="border px-3 py-2">MT</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {production_MT_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Production of Green hydrogen (MT) Value</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {production_MT.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.3</td>
            <td className="border px-3 py-2">Carbon emitted per unit of Green Hydrogen Production (Tonne/ Tonne)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2">Lowest gets max score</td>
            <td className="border px-3 py-2">Number</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {carbon_emitted_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Carbon emitted per unit of Green Hydrogen Production (Tonne/ Tonne) Value</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {carbon_emitted.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.4</td>
            <td className="border px-3 py-2">Purity of Green Hydrogen Produced (%)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2">Highest gets max score</td>
            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {purity_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Purity of Green Hydrogen Produced (%) Value</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {purity.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.5</td>
            <td className="border px-3 py-2">Cost of Production (INR / Tonne)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2">Lowest gets max score</td>
            <td className="border px-3 py-2">INR/Tonne</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {cost_production_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Cost of Production (INR / Tonne) Value</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {cost_production.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2</td>
            <td className="border px-3 py-2"><strong>Investment in Green Hydrogen</strong></td>
            <td className="border px-3 py-2">20</td>
            <td className="border px-3 py-2">20</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {investment_growth.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2.1</td>
            <td className="border px-3 py-2">Investment in Green Hydrogen production/transportation/distribution/storage (INR Crores)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2">Highest gets max score</td>
            <td className="border px-3 py-2">Number</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {investment_production_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Investment in Green Hydrogen production/transportation/distribution/storage (INR Crores) Value</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {installed_capacity.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2.2</td>
            <td className="border px-3 py-2">Growth (%) in investment in Green Hydrogen production/transportation/distribution/storage</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2">Highest gets max score</td>
            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {growth_investment_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">in 2024-25 (INR Crores)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {growth_investment_2024.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">in 2023-24 (INR Crores)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {growth_investment_2023.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">3</td>
            <td className="border px-3 py-2"><strong>Investment in Electrolyser/ Membrane Manufacturing</strong></td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {investment_electrolyser_growth.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">3.1</td>
            <td className="border px-3 py-2">Investment in Electrolyser/ Membrane Manufacturing (INR Crores)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2">Highest gets max score</td>
            <td className="border px-3 py-2">Number</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {investment_electrolyser_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Investment in Electrolyser/ Membrane Manufacturing (INR Crores) Value</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {installed_capacity.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">3.2</td>
            <td className="border px-3 py-2">Growth (%) in investment in Electrolyser / Membrane Manufacturing</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2">Highest gets max score</td>
            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {growth_electrolyser_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">in 2024-25 (INR Crores)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {installed_capacity.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">in 2023-24 (INR Crores)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {installed_capacity.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">4</td>
            <td className="border px-3 py-2"><strong>R&D in Green Hydrogen production/ transportation/distribution/ storage areas</strong></td>
            <td className="border px-3 py-2">15</td>
            <td className="border px-3 py-2">15</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {r_n_d_growth.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">4.1</td>
            <td className="border px-3 py-2">Patents filed in the Assessment year</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">3</td>
            <td className="border px-3 py-2">Highest gets max score</td>
            <td className="border px-3 py-2">Number</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {patent_filed_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Patents filed in the Assessment year Value</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {patent_filed.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">4.2</td>
            <td className="border px-3 py-2">Total Patents Granted (National)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">3</td>
            <td className="border px-3 py-2">Highest gets max score</td>
            <td className="border px-3 py-2">Number</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {patent_national_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Total Patents Granted (National) Value</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {patent_national.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">4.3</td>
            <td className="border px-3 py-2">Total Patents Granted (International)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">4</td>
            <td className="border px-3 py-2">Highest gets max score</td>
            <td className="border px-3 py-2">Number</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {patent_international_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Total Patents Granted (International) Value</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {patent_international.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">4.4</td>
            <td className="border px-3 py-2">Patents Commercialized</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2">Highest gets max score</td>
            <td className="border px-3 py-2">Number</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {patent_commercial_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Patents Commercialized Value</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {patent_commercial.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"><strong>Upcoming Projects</strong></td>
            <td className="border px-3 py-2">20</td>
            <td className="border px-3 py-2">20</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {upcoming_project_growth.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">5.1</td>
            <td className="border px-3 py-2">Project Capacity - Schedule (B/A)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">Number</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {installed_capacity.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">Formula: (B/A)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {project_formula.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">Completed Year: (Project Completion Year - Current Year) - (B)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {project_completed_year.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">Project Completion year</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {project_completion_year.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 0)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">Capacity - (A)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {project_capacity.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">5.2</td>
            <td className="border px-3 py-2"><strong>Project Size - Progress Status</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {installed_capacity.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Grand Total</strong></td>
            <td className="border px-3 py-2">100</td>
            <td className="border px-3 py-2">100</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            {Total_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">{safeFmt(v, 2)}</td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default GHscoretable;